var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('guard',{attrs:{"if-admin":['list_bulk_action_results']}},[_c('bulk-action-results-table',{attrs:{"id":"BAR1","bulk-action":_vm.$bulkActionData.bulkAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }